import React from 'react'
import './Divider.less'

const Divider = ({ children }) => <div className="divider">{children && <div className="divider-text">{children}</div>}<div className="divider-line" /></div>

export default Divider